import React from "react";
import Layout from "../components/Layout";
import CartCard from "../components/CartCard";
import BillDetails from "../components/BillDetails";
import { useSelector } from "react-redux";

export default function Cart() {
  const { cart } = useSelector((store) => store.product);

  let content = null;

  if (cart.length > 0) {
    content = cart.map((cart_product) => (
      <CartCard key={cart_product.product_id} cart_product={cart_product} />
    ));
  } else if (cart.length === 0) {
    content = <h3>There are no products in the cart.</h3>;
  }
  return (
    <Layout>
      
      <div className="container 2xl:px-8 px-2 mx-auto">
        <h2 className="mb-8 text-xl font-bold">Shopping Cart</h2>
        <div className="cartListContainer">
          <div className="space-y-6">{content}</div>
          <BillDetails />
        </div>
      </div>
    </Layout>
  );
}
